import { render, html } from "lit-html";
import * as Board from "@escapio/portal/components/board";
import { translate } from "@escapio/shared/l10n/translate";
import { FilterWithInitialLoadingStyle } from "./FilterWithInitialLoadingStyle";

export default class extends FilterWithInitialLoadingStyle {
	render(board, priceFiltersVisible) {
		this.style.display = priceFiltersVisible ? "" : "none";
		const template = html`
			<div class="filter-box__section-title">
				${translate("hotel_list_board_filter_header")}
			</div>
			${Object.entries(Board.OPTIONS).map(
				([key, label]) =>
					html`<label class="form-radio">
						<input
							class="form-radio__input"
							type="radio"
							value=${key}
							.checked=${board == key}
							@change=${this.onChange}
						/>
						<span class="form-radio__label">${label}</span>
					</label>`,
			)}
		`;
		render(template, this, { host: this });

		// remove min-height after rendering component
		this.removeInitialLoading();
	}
}
